import type { ActionPermissionResult } from '@common/api/actionPermission/actionPermissionActionResult';
import type { ActionsPermission } from '@common/enums/actionPermission';
import { fetchJson } from '@frontend/store/fetch';

export async function getOneActionPermission({
    action,
    query = {},
    signal,
}: {
    action: ActionsPermission;
    query?: Record<string, string>;
    signal: AbortSignal;
}): Promise<ActionPermissionResult> {
    const url = (() => {
        const urlParts = [`/api/actionPermissions/${action}`];
        const searchParams = new URLSearchParams(query).toString();

        if (searchParams) {
            urlParts.push(searchParams);
        }

        return urlParts.join('?');
    })();

    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}
